import 'react-bootstrap-typeahead'
import { Typeahead } from 'react-bootstrap-typeahead'
import React, { useState, useEffect } from 'react'
import { Card, Form } from 'react-bootstrap'
import ApiEndpoints, { BASE_URL } from './ApiEndpoints'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import axios from 'axios'

const SelectableField = ({
  onSelect,
  showStudent,
  showCourse,
  showClass,
  abc,
  setData,
  resetTrigger,
}) => {
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [allStudents, setAllStudents] = useState([]) // Store all students
  const [filteredStudents, setFilteredStudents] = useState([]) // Store filtered students
  const [selectedFilters, setSelectedFilters] = useState({
    course: '',
    class: '',
    student: '',
  })
  const [selectedStudentId, setSelectedStudentId] = useState('')

  useEffect(() => {
    setSelectedFilters({
      course: '',
      class: '',
      student: '',
    })
  }, [resetTrigger])
  // Fetch all courses
  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((res) => setCourses(res.data.data))
      .catch((err) => console.error('Error fetching courses:', err))
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }
    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)

        setData(response.data.data)
        setAllStudents(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])

  // Fetch classes based on selected course
  useEffect(() => {
    if (selectedFilters.course) {
      ApiEndpoints.getAllClassesByCourseId(selectedFilters.course)
        .then((res) => setClasses(res.data.data))
        .catch((err) => console.error('Error fetching classes:', err))
    } else {
      setClasses([])
      setFilteredStudents([]) // Reset students if no course selected
    }
  }, [selectedFilters.course])

  // Filter students based on selected class_id
  const fetchStudentsByClass = async (classId) => {
    try {
      const institueId = Cookies.get('institute_id')

      let token = null
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        institute_id: Number(institueId),
      }

      const response = await axios.get(
        BASE_URL+`/get/student/by-class?class_id=${classId}`,
        { headers },
      )

      console.log('Filtered Students from API:', response.data.data)
      setFilteredStudents(response.data.data)
    } catch (error) {
      console.error(
        error.response?.data?.message || 'Failed to fetch students by class.',
      )
      setFilteredStudents([]) // reset if error
    }
  }
  useEffect(() => {
    console.log('Selected Class ID:', selectedFilters.class)

    if (selectedFilters.class) {
      fetchStudentsByClass(selectedFilters.class)
    } else {
      console.log('No class selected, resetting filtered students.')
      setFilteredStudents([])
    }
  }, [selectedFilters.class])

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    setSelectedFilters({ course: courseId, class: '', student: '' })
    setClasses([])
    setFilteredStudents([])
    onSelect({ course: courseId, class: '', student: '' })
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    const instituteId = Cookies.get('institute_id')

    const headers = {
      institute_id: Number(instituteId),
    }

    setSelectedFilters((prev) => ({ ...prev, class: classId, student: '' }))
    // setFilteredStudents(
    //   allStudents.filter((student) => String(student.class_id) === classId),
    // )

    if (classId) {
      // const institueId = Cookies.get('institute_id')
      // const headers = {
      //   institute_id: Number(institueId),
      // }
      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${classId}`,
          { headers },
        )
        .then((res) => {
          const classStudents = res.data.data || []
          console.log('Fetched Students by class:', classStudents)

          setFilteredStudents(classStudents) // for dropdown
          setData(classStudents) // for table

          // Notify parent with new filters
          onSelect({
            ...selectedFilters,
            class: classId,
            student: '',
          })
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            console.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            console.error('Something went wrong while fetching classes.')
          }
          setFilteredStudents([])
          setClasses([])
        })
    }

    // onSelect({ ...selectedFilters, class: classId, student: '' })
  }
  // const handleStudentChange = (e) => {
  //   const studentId = e.target.value

  //   // Find the selected student by ID from filtered students
  //   const selectedStudent = filteredStudents.find(
  //     (student) => student.id === Number(studentId),
  //   )

  //   console.log('Selected Student:', selectedStudent) // Debugging

  //   setSelectedFilters((prev) => ({
  //     ...prev,
  //     student: studentId,
  //   }))

  //   // Pass the full student data to setData
  //   if (selectedStudent) {
  //     // setData(selectedStudent)
  //     onSelect({ ...selectedFilters, studentId: studentId })
  //   } else {
  //     // setData(null)
  //     onSelect({ ...selectedFilters, student: studentId })
  //   }
  // }
  const handleStudentChange = (e) => {
    const studentId = e.target.value
    console.log('studentId:', studentId)
    setSelectedStudentId(studentId)
    const selectedStudent = filteredStudents.find(
      (student) => student.id === Number(studentId),
    )

    console.log('selectedStudent:', selectedStudent)

    const updatedFilters = {
      ...selectedFilters,
      student: studentId,
    }

    setSelectedFilters(updatedFilters)

    if (onSelect) {
      onSelect(updatedFilters)
      console.log('After onSelect:', updatedFilters)
    }
  }

  return (
    <Card className="p-0 mt-2 border-0 text-start container">
      <div className="row g-3 align-items-start">
        {showCourse && (
          <div className="col-12 col-md-4">
            <Form.Group className="mb-4 text-start fw-bold">
              <Form.Label>Select Course</Form.Label>
              {/* <Form.Select
                value={selectedFilters.course}
                onChange={handleCourseChange}
              >
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course.id} value={abc ? course.id : course.name}>
                    {course.name}
                  </option>
                ))}
              </Form.Select> */}
              <Typeahead
                id="course-select"
                labelKey="name"
                onChange={(selected) => {
                  const course = selected[0]
                  if (course) {
                    handleCourseChange({ target: { value: course.id } })
                  } else {
                    handleCourseChange({ target: { value: '' } })
                  }
                }}
                options={courses}
                placeholder="Select Course"
                selected={courses.filter(
                  (course) => course.id === Number(selectedFilters.course),
                )}
              />
            </Form.Group>
          </div>
        )}
        {showClass && (
          <div className="col-12 col-md-4">
            <Form.Group className="mb-3 text-start fw-bold">
              <Form.Label>Select Class</Form.Label>
              {/* <Form.Select
                value={selectedFilters.class}
                onChange={handleClassChange}
              >
                <option value="">Select Class</option>
                {classes.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.class_name}
                  </option>
                ))}
              </Form.Select> */}
              <Typeahead
                id="class-select"
                labelKey="class_name"
                onChange={(selected) => {
                  const cls = selected[0]
                  if (cls) {
                    handleClassChange({ target: { value: cls.id } })
                  } else {
                    handleClassChange({ target: { value: '' } })
                  }
                }}
                options={classes}
                placeholder="Select Class"
                selected={classes.filter(
                  (cls) => cls.id === Number(selectedFilters.class),
                )}
              />
            </Form.Group>
          </div>
        )}
        {showStudent && (
          <div className="col-12 col-md-4">
            <Form.Group className="mb-3 text-start fw-bold">
              <Form.Label>Select Student</Form.Label>
              {/* <Form.Select
                value={
                  filteredStudents == 'Abc'
                    ? selectedFilters.student
                    : selectedFilters.student
                }
                onChange={handleStudentChange}
              >
                <option value="">Select Student</option>
                {filteredStudents.map((student) => (
                  <option
                    key={student.id}
                    value={student.name}
                    // value={selectedFilters?abc:filteredStudents:""}
                  >
                    {student.name} - {student.admission_number}
                  </option>
                ))}
              </Form.Select> */}

              <Typeahead
                id="student-select"
                labelKey={(student) =>
                  `${student.name} - ${student.admission_number}`
                }
                onChange={(selected) => {
                  const student = selected[0]
                  if (student) {
                    handleStudentChange({ target: { value: student.id } })
                  } else {
                    handleStudentChange({ target: { value: '' } })
                  }
                }}
                options={filteredStudents}
                placeholder="Select Student"
                selected={filteredStudents.filter(
                  (std) => std.id === Number(selectedFilters.student),
                )}
              />
            </Form.Group>
          </div>
        )}
      </div>
    </Card>
  )
}

export default SelectableField
